import React from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import dangerIcon from '../../assets/dangerIcon.svg'

export const ErrorAlert = ({ errorTitle, message, showModal, setShowModal, children }) => {
  return (
    <CustomModal
      showModal={showModal}
      setShowModal={setShowModal}
      title={''}
      size={'lg'}
    >
      <div className='d-flex flex-column align-items-center gap-4'>
        <img
          src={dangerIcon}
          alt=""
        />
        <h4>{errorTitle}</h4>
        <p
          style={{ fontSize: '18px', color: '#657C97' }}
        >
          {message}
        </p>
        <button
          className='btn btn-secondary-gd pe-5 ps-5'
          style={{ fontSize: '18px', borderRadius: '10px' }}
          onClick={setShowModal}
        >
          OK
        </button>
        {children}
      </div>
    </CustomModal>
  )
}
